<template>
  <div
    id="app"
    :class="!isProduction ? 'has-environment-indicator' : ''"
    :dir="currentDirection"
  >
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'App',
  computed: {
    ...mapGetters('translations', ['currentDirection']),
    isProduction() {
      return process.env.VUE_APP_ENV === 'production'
    },
  },
  watch: {
    currentDirection(newValue) {
      document.documentElement.setAttribute('dir', `${newValue}`)
    },
  },
  created() {
    // ada chatbot init
    if (window.adaEmbed) {
      window.adaEmbed.start({
        handle: 'tamara',
      })
    }
  },
}
</script>
